var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25198 9.86993L2.8888 6.50682C2.40301 6.02103 1.6154 6.02104 1.12961 6.50683C0.643815 6.99262 0.643818 7.78025 1.12961 8.26604L5.55335 12.6897C5.94388 13.0802 6.57704 13.0802 6.96756 12.6897L14.914 4.74333C15.4021 4.2552 15.4021 3.46378 14.914 2.97565C14.4258 2.48751 13.6344 2.48751 13.1463 2.97564L6.25198 9.86993Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.36146e70.svg";
export { ForwardRef as ReactComponent };